















import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class Polygon8 extends Vue {
    @Prop() private userConfigColor! : string;
}
